import React, {Component} from "react"
import PropTypes from "prop-types"
import {Row, Col, Panel} from "react-bootstrap"

import {TextArea} from "@irati/ui/src/FormItem"
import Validation from "@irati/utils/validation"
import MarkDown from "@irati/ui/src/Markdown"
import ErrorText from "@irati/ui/src/ErrorText"
import id from "@irati/utils/id"
import {
  containsHeadings,
  containsHorizontalRules,
  containsImages,
  containsItalicStyling,
  containsLegacyBulletPoints,
  containsHtml,
  getErrorIfContains,
  containsInvalidDoubleBulletPoints
} from "@irati/utils/markdown"
import StyledMarkdownCol from "../deal/styled/MarkdownCol"
import withRewardOnChange from "./withRewardOnChange"

const getError = (value) => {
  if (!value) {
    return null
  }
  return getErrorIfContains(value, [
    containsItalicStyling,
    containsImages,
    containsHeadings,
    containsHorizontalRules,
    containsLegacyBulletPoints,
    containsHtml,
    containsInvalidDoubleBulletPoints
  ])
}

export const schema = Validation.string().test(
  "description-md-valid",
  "error",
  (value) => {
    return Validation.customError(getError(value))
  }
)


const PROPERTY = "termsAndConditions"

class TermsAndConditions extends Component {
  static propTypes = {
    reward: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    required: PropTypes.bool,
    label: PropTypes.string,
    panelTitle: PropTypes.string,
    validation: PropTypes.object
  }

  static defaultProps = {
    required: false,
    label: "T&Cs:",
    hint: "Available markdown: Bullet points, bold styling, links.",
    panelTitle: "How it will display",
    validation: schema,
    id: "termsAndConditions"
  }

  render() {
    const {reward, required, label, panelTitle, onChange, ...props} = this.props

    const error = getError(reward[PROPERTY] || "")

    return (
      <Row>
        <Col xs={6}>
          <TextArea
            name={PROPERTY}
            value={reward[PROPERTY]}
            rows={8}
            label={`${label}${required ? "*" : ""}`}
            {...props}
            onChange={(value) => onChange(reward, PROPERTY, value)}
            id={id(PROPERTY, props)} />
        </Col>
        <StyledMarkdownCol xs={6}>
          <Panel bsStyle="info" header={panelTitle}>
            {!error && <MarkDown source={reward[PROPERTY]} />}
            {error && <ErrorText>{error}</ErrorText>}
          </Panel>
        </StyledMarkdownCol>
      </Row>
    )
  }
}

export default withRewardOnChange(TermsAndConditions)
